import React, { Component, Fragment } from "react";

import UpdateFolderForm from "../../containers/UpdateFolderForm";

class UpdateFolderModal extends Component {
  constructor(props) {
    super(props);

    this.cancel = this.cancel.bind(this);
  }

  cancel() {
    this.props.handleCloseModal();
  }

  render() {
    return (
      <Fragment>
        <div className="modal__header">
          <span>{this.props.t("modals:modifyMyFolder")}</span>
        </div>

        <div className="modal__body">
          <div className="modal__close" onClick={this.props.handleCloseModal}>
            <svg className="bars-icon" viewBox="0 0 24 24">
              <path d="M1,1 L22,22 M1,22 L22,1" stroke="#000" strokeWidth="1" />
            </svg>
          </div>
          <UpdateFolderForm handleCancel={this.cancel} t={this.props.t}/>
        </div>
      </Fragment>
    );
  }
}

export default UpdateFolderModal;



// WEBPACK FOOTER //
// ./src/components/modals/UpdateFolderModal.js